module.exports = __webpack_public_path__ + "img/bancodechile.063cdbc.png";